import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';

@Component({
  selector: "app-datetime",
  template: `
<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="12px" style="gap: 12px; width: 100%;">
  <mat-form-field fxFlex="60" [appearance]="formType" fxclass="demo-full-width margin-top">
    <mat-label>{{field.label}}</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="dateValue" (dateChange)="onDateTimeChange()" [required]="isRequired">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint></mat-hint>
    <ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
  </mat-form-field>

  <mat-form-field fxFlex="40" [appearance]="formType" fxclass="demo-full-width margin-top">
    <mat-label>Time</mat-label>
    <input matInput type="time" [(ngModel)]="timeValue" (input)="onDateTimeChange()" (change)="onDateTimeChange()">
  </mat-form-field>
</div>
`,
  styles: []
})
export class DatetimeComponent implements OnInit {
  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  display: boolean = false;
  formType: any;
  dateValue: any = null;
  timeValue: string = '';

  get isRequired(): boolean {
    if (!this.group || !this.field || !this.field.name) return false;
    const ctrl = this.group.get(this.field.name);
    return ctrl ? ctrl.errors?.required !== undefined : false;
  }

  constructor() {}

  ngOnInit() {
    this.initFromGroup();
    if (this.group && this.field?.name) {
      this.group.get(this.field.name)?.valueChanges.subscribe(val => {
        if (val !== this.getCombinedValue()) {
          this.initFromGroup();
        }
      });
    }
  }

  initFromGroup() {
    if (!this.group || !this.field?.name) return;
    const rawVal = this.group.get(this.field.name)?.value;
    if (!rawVal) {
      this.dateValue = null;
      this.timeValue = '';
      return;
    }
    if (rawVal instanceof Date) {
      this.dateValue = rawVal;
      const hh = rawVal.getHours().toString().padStart(2, '0');
      const mm = rawVal.getMinutes().toString().padStart(2, '0');
      this.timeValue = `${hh}:${mm}`;
    } else if (typeof rawVal === 'string') {
      const str = rawVal.trim();
      if (str.includes('T') || str.includes(' ')) {
        const separator = str.includes('T') ? 'T' : ' ';
        const parts = str.split(separator);
        this.dateValue = new Date(str);
        if (isNaN(this.dateValue.getTime())) {
          this.dateValue = new Date(parts[0]);
        }
        if (parts[1]) {
          this.timeValue = parts[1].substring(0, 5);
        }
      } else {
        this.dateValue = new Date(str);
        this.timeValue = '';
      }
    }
  }

  onDateTimeChange() {
    if (!this.group || !this.field?.name) return;
    const combined = this.getCombinedValue();
    const ctrl = this.group.get(this.field.name);
    if (ctrl) {
      ctrl.setValue(combined);
      ctrl.markAsDirty();
      ctrl.markAsTouched();
    }
  }

  getCombinedValue(): string | null {
    if (!this.dateValue) return null;
    let d: Date;
    if (this.dateValue instanceof Date) {
      d = this.dateValue;
    } else {
      d = new Date(this.dateValue);
    }
    if (!d || isNaN(d.getTime())) return null;

    const yyyy = d.getFullYear();
    const MM = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');

    const time = this.timeValue ? this.timeValue.trim() : '00:00';
    const timeParts = time.split(':');
    const hh = (timeParts[0] || '00').padStart(2, '0');
    const mm = (timeParts[1] || '00').padStart(2, '0');
    const ss = timeParts[2] ? timeParts[2].padStart(2, '0') : '00';

    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}`;
  }
}
